var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-nav-bar', _vm._g(_vm._b({
        scopedSlots: _vm._u([
            {
                key: "background",
                fn: function fn() {
                    return [
                        _vm._t("background")
                    ];
                },
                proxy: true
            },
            {
                key: "left",
                fn: function fn() {
                    return [
                        _vm._t("left")
                    ];
                },
                proxy: true
            },
            {
                key: "title",
                fn: function fn() {
                    return [
                        _vm._t("title")
                    ];
                },
                proxy: true
            },
            {
                key: "right",
                fn: function fn() {
                    return [
                        _vm._t("right")
                    ];
                },
                proxy: true
            }
        ], null, true)
    }, 'x-nav-bar', _vm.$attrs, false), _setup.navbarListeners));
};
var staticRenderFns = [];
export { render, staticRenderFns };
